import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../services/AuthService';
import { selectRefreshToken } from '../../store/reducers/AuthSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { terminateAuthSession } from '../../utils/http/authSession';

const LogOut: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const refreshToken = useAppSelector(selectRefreshToken);
  const [revokeSession] = useLogoutMutation();

  useEffect(() => {
    const terminateSession = () => {
      terminateAuthSession({
        dispatch,
        redirectToLogin: () => navigate('/login', { replace: true }),
      });
    };

    if (refreshToken) {
      void revokeSession({ refreshToken })
        .unwrap()
        .then(terminateSession, terminateSession);
    } else {
      terminateSession();
    }
  }, [dispatch, navigate, refreshToken, revokeSession]);

  return null;
};

export default LogOut;
